import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  DisableCloudflareEnterpriseComponent
} from "../../../dialogs/disable-cloudflare-enterprise/disable-cloudflare-enterprise.component";
import {DbModalService} from "../../../../../../../modules/modal/modal";

@Component({
    selector: 'db-cdn-disable-enterprise',
    templateUrl: './cdn-disable-enterprise.component.html',
    styleUrls: ['./cdn-disable-enterprise.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CdnDisableEnterpriseComponent implements OnInit {

  @Input() isNameServer: boolean;
  public websiteId: number;
  public disableLoading: boolean;

  constructor(
    private _route: ActivatedRoute,
    private _dbModalService: DbModalService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.websiteId = +this._route.snapshot.parent.parent.params['id'];
  }

  public disable() {

      const modal = this._dbModalService.open(DisableCloudflareEnterpriseComponent);
      modal.componentInstance.websiteId = this.websiteId;
      modal.componentInstance.sizes = {width: 700};
      modal.componentInstance.widthConfirmation = !this.isNameServer ? true : false;
      modal.componentInstance.title = 'Disable Cloudflare Enterprise';
      modal.componentInstance.desc = !this.isNameServer ? 'You won’t be able to use Cloudflare’s Enterprise CDN and security features. <p class="mt30">Revert your DNS records and make sure everything is resolved before proceeding, otherwise your website will be down.</p>'
      : 'You won’t be able to use Cloudflare’s Enterprise CDN and security features. <p class="mt30">By clicking Disable, we will automatically revert your DNS records to ensure<br/> your website’s proper functionality. No manual action is required from your side.</p>' ;

  }
}
